import React from "react";
import PropTypes from "prop-types";
import { Route, Switch, Redirect } from "react-router-dom";

import {
  Admins,
  ADMIN_ROLES,
  BusinessAdmins,
  BusinessUsersWithPbxAdmin,
  BusinessUsers,
} from "constants/userRoles";
import { DEBTOR } from "constants/routes";

import { getCurrentUserRole } from "utils/selectors";

import DebtorDetail from "views/Debtor/DebtorDetail/DebtorDetail";
import DebtorEdit from "views/Debtor/DebtorEdit";
import DebtorCreate from "views/Debtor/DebtorCreate";
import DebtorIndex from "views/Debtor/DebtorIndex";
import AgreementCreate from "views/Agreement/AgreementCreate";
import PbxCreate from "views/Pbx/PbxCreate";
import ContactIndex from "views/Contact/ContactIndex";
import AgreementIndex from "views/Agreement/AgreementIndex";
import InvoiceIndex from "views/Invoice/InvoiceIndex";
import CreditNotes from "views/CreditNotes/CreditNotesIndex";
import PbxIndex from "views/Pbx/PbxIndex";

const AdminDebtorRoutes = () => (
  <>
    <Route path={DEBTOR.SHOW} component={DebtorDetail} />
  </>
);

const UsersDebtorsRoutes = () => (
  <Switch>
    <Route
      exact
      path={DEBTOR.CONTACTS}
      component={BusinessUsers(ContactIndex)}
    />
    <Route exact path={DEBTOR.AGREEMENTS} component={AgreementIndex} />
    <Route
      exact
      path={DEBTOR.INVOICES}
      component={BusinessAdmins(InvoiceIndex)}
    />
    <Route path={DEBTOR.CREDIT_NOTES} component={BusinessAdmins(CreditNotes)} />
    <Route exact path={DEBTOR.PBXS} component={PbxIndex} />
    <Route
      exact
      path={DEBTOR.SHOW}
      render={({ match }) => (
        <Redirect to={DEBTOR.addId(DEBTOR.DETAIL, match.params.debtorID)} />
      )}
    />
    <Route
      path={DEBTOR.DETAIL}
      component={BusinessUsersWithPbxAdmin(DebtorDetail)}
    />
  </Switch>
);

const DebtorRoutes = ({ reduxStore }) => {
  const currentUserRole = getCurrentUserRole(reduxStore.getState());
  const isAdmin = ADMIN_ROLES.includes(currentUserRole);

  return (
    <Switch>
      <Route exact path={DEBTOR.INDEX} component={Admins(DebtorIndex)} />
      <Route path={DEBTOR.CREATE} component={Admins(DebtorCreate)} />
      <Route
        exact
        path={DEBTOR.AGREEMENTS_NEW}
        component={Admins(AgreementCreate)}
      />
      <Route exact path={DEBTOR.PBXS_NEW} component={Admins(PbxCreate)} />
      <Route path={DEBTOR.EDIT} component={BusinessAdmins(DebtorEdit)} />
      {isAdmin ? <AdminDebtorRoutes /> : <UsersDebtorsRoutes />}
    </Switch>
  );
};

DebtorRoutes.propTypes = {
  reduxStore: PropTypes.shape({
    getState: PropTypes.func,
  }).isRequired,
};

export default DebtorRoutes;
